export default function downloadFile(filename, content, type) {
    const blob = new Blob([content], { type });
    const downloadLink = document.createElement('a');
    downloadLink.href = URL.createObjectURL(blob);
    downloadLink.setAttribute('download', filename);
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
}



// WEBPACK FOOTER //
// ./src/helpers/DownloadFile.js